// extracted by mini-css-extract-plugin
export var bg = "styles-module--bg--81f28";
export var bg1 = "styles-module--bg1--df93c";
export var bg2 = "styles-module--bg2--61616";
export var bg3 = "styles-module--bg3--f77df";
export var card = "styles-module--card--bf366";
export var text = "styles-module--text--23e6b";